import { Action } from '../core';
export const AUTHORS = {
  entity: 'AUTHORS',
  action: Action.GET
};